module.exports = __webpack_public_path__ + "img/T2D_rc_11.6faed316.png";